import {
  TabsContent,
  TabsList,
  TabsTrigger,
  Tabs as TabsUI,
} from '@baseball-near-you/ui';
import type { Tabs as ITabs } from '@bb/sanity.types';
import { SanityWrapper } from '../SanityWrapper';

export function Tabs({ block }: { block: ITabs }) {
  return (
    <SanityWrapper>
      <TabsUI
        defaultValue={block.tabs?.[0].title}
        className="mx-auto flex h-full w-full max-w-3xl flex-col justify-between"
      >
        <TabsList className="space-x-5 self-center border border-gray-400 py-1 shadow-xs">
          {block.tabs?.map((tab, i) => {
            return (
              <TabsTrigger value={tab.title} key={tab.title + tab.subtitle}>
                {tab.title}
              </TabsTrigger>
            );
          })}
        </TabsList>
        <div className="h-[23rem]">
          {block.tabs?.map((tab, i) => {
            return (
              <TabsContent
                className="h-full"
                value={tab.title}
                key={tab.subtitle + tab.title}
              >
                {tab.subtitle}
              </TabsContent>
            );
          })}
        </div>
      </TabsUI>
    </SanityWrapper>
  );
}
